// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"93b094dd","977":"e59ef413"}[chunkId] + ".chunk.js";
};